import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZLeaderboardAction } from './models';

const c = initContract();

export const adminLeaderboardContract = c.router(
  {
    awardPointsToUserForAction: {
      method: 'POST',
      path: '/award-points',
      body: z.object({
        playerId: z.string(),
        action: ZLeaderboardAction,
      }),
      responses: {
        200: z.object({
          points: z.number(),
        }),
        400: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  }
);
